<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 赋码管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>预生码管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="订单" prop="qrcode_orderno">
                <el-input v-model="searchform.qrcode_orderno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商编码" prop="supplier_id">
                <el-input v-model="searchform.supplier_id" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生码状态" prop="qrcode_status">
                <el-select
                  v-model="searchform.qrcode_status"
                  style="width:100%"
                  placeholder="请选择码状态"
                >
                  <el-option
                    v-for="item in qrcode_status"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="类型" prop="qrcode_order_type">
                <el-select
                  v-model="searchform.qrcode_order_type"
                  style="width:100%"
                  placeholder="请选择数据类型"
                >
                  <el-option
                    v-for="item in qrcode_order_type"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createtime">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.createtime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" style="margin-left:10px">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['readycreate_select']"
              >搜索</el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="add()"
                v-permission="['readycreate_add']"
              >新增</el-button>
              <el-button
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
                v-permission="['readycreate_export']"
              >导出Excel</el-button>
            </el-col>
          </el-row>
          <br />
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            border
            style="width:100%"
            @cell-click="danhang"
          >
            <el-table-column prop="id" label="编码" min-width="50"></el-table-column>
            <el-table-column prop="qrcode_order_type_name" label="类型" min-width="70"></el-table-column>
            <el-table-column prop="qrcode_orderno" label="订单" min-width="110"></el-table-column>
            <el-table-column prop="supplier" label="供应商" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_quantity" label="生码数量" min-width="80"></el-table-column>
            <el-table-column prop="qrcode_status_name" label="生码状态" min-width="70"></el-table-column>
            <el-table-column prop="encryption_flagname" label="是否加密" min-width="70"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="140"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" min-width="140"></el-table-column>
            <el-table-column prop="action" label="操作" min-width="220">
              <template scope="scope">
                <!-- <el-button-group encryption_flag > -->
                <el-button
                  type="primary"
                  size="mini"
                  @click="shengma()"
                  :loading="scope.row.qrcode_status ==1"
                  icon="document"
                  v-show="scope.row.qrcode_quantity !== 0"
                  plain
                  v-permission="['readycreate_produce']"
                >生码</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="update()"
                  v-show="scope.row.qrcode_order_type_name !=='接口推送' && scope.row.qrcode_status !==1 "
                  plain
                  v-permission="['readycreate_update']"
                >修改</el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="closeorder"
                  v-show="scope.row.qrcode_status ==0 && scope.row.qrcode_status !==1"
                  plain
                  v-permission="['readycreate_close']"
                >关闭</el-button>
                <!-- </el-button-group> -->
              </template>
            </el-table-column>
          </el-table>
          <br />
          <!-- 编辑修改弹出框 -->
          <el-dialog title="修改预生码单" :visible.sync="editVisible" width="28%" center>
            <el-form :model="form" ref="form" label-width="100px" :rules="rules">
              <el-row>
                <el-form-item label="订单" v-show="this.form.qrcode_order_type == 0">
                  <el-input v-model="form.qrcode_orderno" style="width:90%" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item
                  label="供应商编码"
                  prop="supplier_id"
                  v-show="this.form.qrcode_order_type == 0"
                >
                  <el-input v-model="form.supplier_id" style="width:90%"></el-input>
                </el-form-item>
                <el-form-item label="生码数量" prop="qrcode_quantity">
                  <el-input v-model.number="form.qrcode_quantity" style="width:90%"></el-input>
                </el-form-item>
                <el-form-item label="生码规则" prop="qrcode_order_type">
                <el-select
                  clearable
                  v-model="form.rule_id"
                  style="width:90%"
                  placeholder="请选择数据类型"
                >
                  <el-option
                    v-for="item in ruletype"
                    :key="item.rule_id"
                    :label="item.rule_name"
                    :value="item.rule_id"
                  ></el-option>
                </el-select>
              </el-form-item>
                <el-form-item label="是否加密" prop="encryption_flag">
                  <el-select
                    v-model="form.encryption_flag"
                    style="width:90%"
                    placeholder="是否加密"
                  >
                    <el-option
                      v-for="item in encryption_flag"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit('form')">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 编辑新增弹出框 -->
          <el-dialog
            title="新建预生码单"
            :visible.sync="dialogVisible"
            width="28%"
            :modal="true"
            center
            @close="resetForm('formadd')"
          >
            <el-form :model="formadd" :rules="rules" ref="formadd" label-width="100px">
              <el-row>
                <el-form-item label="订单">
                  <el-input v-model="formadd.qrcode_orderno" style="width:90%" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="供应商编码" prop="supplier_id">
                  <el-input v-model="formadd.supplier_id" style="width:90%"></el-input>
                </el-form-item>
                <el-form-item label="生码数量" prop="qrcode_quantity">
                  <el-input v-model.number="formadd.qrcode_quantity" style="width:90%"></el-input>
                </el-form-item>
                
          <!--
                <el-form-item label="生码规则" prop="rule_id">
                <el-select
                 clearable
                  v-model="formadd.rule_id"
                  style="width:90%"
                  placeholder="请选择数据类型"
                >
                  <el-option
                    v-for="item in ruletype"
                    :key="item.rule_id"
                    :label="item.rule_name"
                    :value="item.rule_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              -->
              <el-form-item label="生码规则" prop="rule_id">
                <el-select
                  v-model="formadd.rule_id"
                  style="width:100%"
                  placeholder="请输入产品名称模糊匹配或者下拉选择"
                  :remote-method="getRuleList"
                  filterable
                  remote
                  :loading="productloading"
                  :disabled="show"
                >
                  <el-option
                    v-for="item in ruleFuzzyList"
                    :key="item.rule_id"
                    :label="item.rule_name"
                    :value="item.rule_id"
                  />
                </el-select>
              </el-form-item>
                <el-form-item label="是否加密" prop="encryption_flag">
                  <el-select
                    v-model="formadd.encryption_flag"
                    style="width:90%"
                    placeholder="是否加密"
                  >
                    <el-option
                      v-for="item in encryption_flag"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false,resetForm('formadd')">取 消</el-button>
              <el-button @click="resetForm('formadd')">重置</el-button>
              <el-button type="primary" @click="submitadd('formadd')">确 定</el-button>
            </span>
          </el-dialog>
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[20,30,40,50,100]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
          <el-divider></el-divider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  neworderno,
  readycreatebuild,
  getcodefilepath,
  getunbuildorders,
  getcodefile,
  readycreatelist,
  readycreateupdate,
  rulenewsquery,
  readycreateadd,
  readycreatedelete,
  updateclose,
  FuzzyQuery,
  findmaster
} from "@/api/tagging";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
    //请求下拉菜单数据 部门菜单
    //角色类别
    rulenewsquery().then(response => {
      this.role_uuid = response.data;
      this.formadd.rule_id = response.data.rule_id;
      this.form.rule_id = response.data.rule_id;
    });
    findmaster().then(response => {
      this.ruletype = response.data.data;
    });
    FuzzyQuery('').then(response=>{
      this.ruleFuzzyList = response.data;
    });
  },
  data() {
    // 新增校验两次密码输入是否一致
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("不能为空"));
      } else if (value <= 0 || value > 10000000) {
        callback(new Error("数量必须在1-10000000"));
      } else {
        callback();
      }
    };
    return {
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //基础数据
      openIsDisabled: false,
      listLoading: false,
      dialogVisible: false,
      editVisible: false,
      account_status: [],
      role_uuid: [],
      tableData: [],
      ruletype:[],
      ruleFuzzyList:[],
      //下拉菜单
      qrcode_status: [
        {
          key: 0,
          label: "未生码"
        },
        {
          key: 1,
          label: "生码中"
        }
      ],
      encryption_flag: [
        {
          key: 0,
          label: "加密"
        },
        {
          key: 1,
          label: "不加密"
        }
      ],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      qrcode_order_type: [
        {
          key: 0,
          label: "手工创建"
        },
        {
          key: 1,
          label: "接口推送"
        }
      ],
      searchform: {
        qrcode_orderno: "",
        qrcode_status: null,
        qrcode_order_type: null,
        createtime: "",
        supplier_id: "",
        rule_id: "",
        page_index: 1,
        page_size: 20
      },
      //修改表单数据
      form: {
        encryption_flag: null,
        id: "",
        qrcode_orderno: "",
        qrcode_order_type: "",
        rule_id: "",
        supplier_id: "",
        qrcode_status: "",
        enterprise_code: "",
        qrcode_quantity: "",

        user_uuid: "" //删除按钮传参
      },
      //新增弹窗变量begin
      //新增表单数据
      formadd: {
        encryption_flag: 0,
        qrcode_orderno: "",
        qrcode_quantity: "",
        supplier_id: "",
        rule_id: "",
      },
      //基础表单验证
      rules: {
        qrcode_orderno: [
          { required: true, message: "请输入物料订单", trigger: "blur" }
        ],
        qrcode_quantity: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          { type: "number", message: "数量必须为数字值" }
        ],

        supplier_id: [
          { required: true, message: "请输入包材供应商编码", trigger: "blur" }
        ],
        rule_id: [{ required: true, message: "请选择规则", trigger: "change" }]
      },
      //进度条
      loading: "",
      percentage: 0,
      timer: "",
      timerlist: []
    };
  },
  beforeDestroy() {
    // 离开界面关闭轮询
    for (let i = 0; i < this.timerlist.length; i++) {
      clearInterval(this.timerlist[i]);
    }
  },
  methods: {
    getRuleList(value) {
      if (value !== '') {
        this.productloading = true
        setTimeout(() => {
          this.productloading = false
          FuzzyQuery({ ruleName: value }).then(response => {
            this.ruleFuzzyList = response.data
          })
        }, 200)
      } else {
        this.ruleFuzzyList = []
      }
    },
    // 新增调接口获取订单
    add() {
      this.dialogVisible = true;
      neworderno().then(response => {
        this.formadd.qrcode_orderno = response.data;
      });
    },
    //请求表格数据
    //拼接包材供应商id+name
    tablefor() {
      const len = this.tableData.length;
      for (let i = 0; i < len; i++) {
        if (this.tableData[i].update_time == "0001-01-01T00:00:00") {
          this.tableData[i].update_time = " ";
        }
        this.tableData[i].create_time = this.tableData[i].create_time.replace(
          /T/,
          " "
        );
        this.tableData[i].update_time = this.tableData[i].update_time.replace(
          /T/,
          " "
        );
        switch (this.tableData[i].encryption_flag) {
          case 0:
            this.tableData[i].encryption_flagname = "加密";
            break;
          case 1:
            this.tableData[i].encryption_flagname = "不加密";
            break;
          default:
            break;
        }
        if (this.tableData[i].supplier_name !== null) {
          this.tableData[i].supplier =
            this.tableData[i].supplier_id + this.tableData[i].supplier_name;
        } else {
          this.tableData[i].supplier = this.tableData[i].supplier_id;
        }
      }
    },
    //请求表格数据
    Tabledata(obj) {
      readycreatelist(obj).then(response => {
        this.tableData = response.data.data;
        this.tablefor();
        this.total_count = response.data.total_count;
        console.log(response.data);
        console.log(this.$store.state);
      });
    },
    //保存提示
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.dialogVisible = false;
          readycreateadd({
            encryption_flag: this.formadd.encryption_flag,
            qrcode_orderno: this.formadd.qrcode_orderno,
            qrcode_quantity: Number(this.formadd.qrcode_quantity),
            supplier_id: this.formadd.supplier_id,
            rule_id: this.formadd.rule_id,
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.resetForm(formName);
              this.Tabledata();
              console.log(this.formadd.rule_id);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //搜索事件
    search() {
      for (let i = 0; i < this.timerlist.length; i++) {
        clearInterval(this.timerlist[i]);
      }
      this.Tabledata({
        page_size: this.searchform.page_size,
        supplier_id: this.searchform.supplier_id,
        create_start_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[0],
        create_end_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[1],
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(page_index) {
      this.searchform.page_index = page_index;
      this.Tabledata({
        page_index: this.searchform.page_index,
        page_size: this.searchform.page_size,
        supplier_id: this.searchform.supplier_id,
        create_start_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[0],
        create_end_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[1],
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      });
    },
    //分页每页显示条数事件
    pagesize(page_size) {
      this.searchform.page_size = page_size;
      this.search();
    },
    //表格单行点击
    danhang(row) {
      this.form.id = row.id;
      this.form.rule_id = row.rule_id;
      this.form.qrcode_orderno = row.qrcode_orderno;
      this.form.qrcode_order_type = row.qrcode_order_type;
      this.form.qrcode_quantity = row.qrcode_quantity;
      this.form.supplier_id = row.supplier_id;
      this.form.qrcode_status = row.qrcode_status;
      this.form.enterprise_code = row.enterprise_code;
      this.form.encryption_flag = row.encryption_flag;
      console.log(row);
    },
    // 修改弹窗确定按钮       请求接口！！
    submit(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.editVisible = false;
          readycreateupdate({
            encryption_flag: this.form.encryption_flag,
            id: this.form.id,
            qrcode_orderno: this.form.qrcode_orderno,
            rule_id: this.form.rule_id,
            supplier_id: this.form.supplier_id,
            qrcode_quantity: Number(this.form.qrcode_quantity),
            enterprise_code: this.enterprise_code
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.Tabledata({ PageIndex: this.currentPage });
            } else {
              this.$message({
                type: "woring",
                message: "修改失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改按钮弹窗
    update() {
      (this.requestnum = "1"), (this.editVisible = true); //弹窗false关闭 true开启
    },
    //生码请求接口
    shengma() {
      setTimeout(() => {
        readycreatebuild({ id: this.form.id }).then(response => {
          if (response.status_code == 200) {
            //   clearInterval(this.timer);关闭轮询
            this.Tabledata();
            this.open1();
            this.timer = setInterval(this.Tabledata, 2000);
            this.timerlist.push(this.timer);
          } else {
            this.$message({
              type: "woring",
              message: "生码失败!服务器出错！"
            });
          }
        });
      }, 100);
    },
    //生码完成提示
    open1() {
      this.$notify({
        message: "开始生码，生码完成后可在生码记录表中查看",
        type: "success"
      });
    },
    open2() {
      this.$notify({
        title: "警告",
        message: "生码失败！",
        type: "warning"
      });
    },
    //生码遮布
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
        closeorder() {
      this.$confirm("此操作将关闭该预生码单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          updateclose({
            id: this.form.id
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "关闭成功!"
              });
              this.Tabledata();
            } else {
              this.$message({
                type: "woring",
                message: "关闭失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: this.searchform.page_index,
        page_size: this.total_count,
        supplier_id: this.searchform.supplier_id,
        create_start_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[0],
        create_end_time:
          this.searchform.createtime == null
            ? null
            : this.searchform.createtime[1],
        qrcode_orderno: this.searchform.qrcode_orderno,
        qrcode_order_type: this.searchform.qrcode_order_type,
        qrcode_status: this.searchform.qrcode_status
      };
      readycreatelist(obj).then(response => {
        this.tableDataDownload = response.data.data;
        const len = this.tableDataDownload.length;
        for (let i = 0; i < len; i++) {
          this.tableDataDownload[i].create_time = this.tableDataDownload[
            i
          ].create_time.replace(/T/, " ");
          this.tableDataDownload[i].update_time = this.tableDataDownload[
            i
          ].update_time.replace(/T/, " ");
          switch (this.tableDataDownload[i].encryption_flag) {
            case 0:
              this.tableDataDownload[i].encryption_flag = "加密";
              break;
            case 1:
              this.tableDataDownload[i].encryption_flag = "不加密";
              break;
            default:
              break;
          }
          if (this.tableDataDownload[i].supplier_name !== null) {
            this.tableDataDownload[i].supplier =
              this.tableDataDownload[i].supplier_id +
              this.tableDataDownload[i].supplier_name;
          } else {
            this.tableDataDownload[i].supplier = this.tableDataDownload[
              i
            ].supplier_id;
          }
        }

        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "编码",
            "类型",
            "订单",
            "供应商",
            "生码数量",
            "生码状态",
            "是否加密",
            "创建时间",
            "修改时间"
          ];
          const filterVal = [
            "id",
            "qrcode_order_type_name",
            "qrcode_orderno",
            "supplier",
            "qrcode_quantity",
            "qrcode_status_name",
            "encryption_flag",
            "create_time",
            "update_time"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    }
  }
};
</script>
<style scoped>
</style>
